var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"C-article-info__lead",class:_vm.props.fontSizeClass},_vm._l((_vm.props.lead.content),function(fragment,index){return _c('ContentFragment',{key:index,attrs:{"content":fragment}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }